import { useRef } from 'react';

export default function BrosurPage() {
  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      {/* Yazdır Butonu - Baskıda görünmez */}
      <div className="no-print flex justify-center mb-6 gap-3">
        <button
          onClick={handlePrint}
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white rounded-full font-semibold text-sm hover:bg-[#E55A2B] transition-all cursor-pointer whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-printer-line text-base"></i>
          </span>
          Yazdır / PDF Kaydet
        </button>
        <a
          href="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#1A2332] text-white rounded-full font-semibold text-sm hover:bg-[#253347] transition-all cursor-pointer whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-left-line text-base"></i>
          </span>
          Ana Sayfa
        </a>
      </div>

      <div ref={printRef} className="brochure-wrapper mx-auto" style={{ maxWidth: '794px' }}>

        {/* ── SAYFA 1: KAPAK ── */}
        <div className="brochure-page bg-white mb-6 overflow-hidden" style={{ minHeight: '1123px' }}>
          {/* Kapak Üst — Tam Arka Plan */}
          <div className="relative h-[520px] overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/f76c95829e966c53b77a418f954a6141.jpg"
              alt="Bioetiket Profesyonel Etiket Baskı"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#1A2332]/80 via-[#1A2332]/50 to-[#1A2332]/90"></div>

            {/* Logo & Başlık */}
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-12">
              <img
                src="https://static.readdy.ai/image/09a8ead7418a68887e61601399480989/f761e44d359e887ba9b77959d97e14a2.png"
                alt="Bioetiket Logo"
                className="h-16 w-auto mb-6 drop-shadow-xl"
              />
              <div className="w-16 h-0.5 bg-[#FF6B35] mb-6"></div>
              <h1 className="text-5xl font-bold text-white leading-tight mb-4">
                Markanızı<br />
                <span className="text-[#FF6B35] italic">Etiketinizle</span><br />
                Konuşturun
              </h1>
              <p className="text-base text-white/80 max-w-md leading-relaxed">
                20 yıllık deneyim, son teknoloji baskı makineleri ve sektöre özel çözümlerle profesyonel etiket üretimi
              </p>
            </div>

            {/* Alt Şerit */}
            <div className="absolute bottom-0 left-0 right-0 bg-[#FF6B35] py-3 px-8 flex justify-between items-center">
              <span className="text-white text-sm font-semibold">www.bioetiket.com</span>
              <span className="text-white text-sm">Ümraniye / İstanbul</span>
              <span className="text-white text-sm font-semibold">+90 216 365 88 78</span>
            </div>
          </div>

          {/* Kapak Alt — 4 Özellik */}
          <div className="px-10 py-8">
            <div className="grid grid-cols-4 gap-4 mb-8">
              {[
                { icon: 'ri-medal-line', label: '20+ Yıl', sub: 'Deneyim' },
                { icon: 'ri-group-line', label: '800+', sub: 'Müşteri' },
                { icon: 'ri-rocket-line', label: '24 Saat', sub: 'Teslimat' },
                { icon: 'ri-award-line', label: '%98', sub: 'Memnuniyet' },
              ].map((s, i) => (
                <div key={i} className="text-center p-4 bg-[#FAFAF8] rounded-2xl border border-gray-100">
                  <div className="w-10 h-10 bg-[#FF6B35]/10 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className={`${s.icon} text-xl text-[#FF6B35]`}></i>
                  </div>
                  <div className="text-xl font-bold text-[#1A2332]">{s.label}</div>
                  <div className="text-xs text-gray-500 mt-0.5">{s.sub}</div>
                </div>
              ))}
            </div>

            <div className="bg-[#1A2332] rounded-2xl p-6 text-white">
              <h2 className="text-xl font-bold mb-3 text-[#FF6B35]">Hakkımızda</h2>
              <p className="text-sm text-gray-300 leading-relaxed">
                Bioetiket olarak 2004 yılından bu yana İstanbul Ümraniye'de, gıdadan kozmetiğe, ilaçtan endüstriyele kadar her sektöre özel yüksek kaliteli etiket üretimi gerçekleştiriyoruz. Dijital ve flekso baskı teknolojilerimizle 100 adetten milyonlarca adede kadar tüm hacimlerde üretim yapıyoruz.
              </p>
              <p className="text-sm text-gray-300 leading-relaxed mt-3">
                Müşteri memnuniyetini ön planda tutarak, her siparişte en yüksek baskı kalitesini ve zamanında teslimatı garanti ediyoruz. ISO sertifikalı üretim süreçlerimizle sektörün güvenilir iş ortağıyız.
              </p>
            </div>
          </div>
        </div>

        {/* ── SAYFA 2: HİZMETLER ── */}
        <div className="brochure-page bg-white mb-6 overflow-hidden" style={{ minHeight: '1123px' }}>
          {/* Başlık Bandı */}
          <div className="bg-[#1A2332] px-10 py-8">
            <div className="flex items-end justify-between">
              <div>
                <span className="text-xs font-semibold tracking-widest text-[#FF6B35] uppercase">Hizmetlerimiz</span>
                <h2 className="text-4xl font-bold text-white mt-2">
                  Sektöre Özel<br />
                  <span className="text-[#FF6B35] italic">Etiket Çözümleri</span>
                </h2>
              </div>
              <img
                src="https://static.readdy.ai/image/09a8ead7418a68887e61601399480989/f761e44d359e887ba9b77959d97e14a2.png"
                alt="Bioetiket"
                className="h-10 w-auto opacity-70"
              />
            </div>
          </div>

          <div className="px-10 py-8 space-y-5">
            {[
              {
                icon: 'ri-restaurant-line',
                color: '#2D7D46',
                title: 'Gıda Etiketleri',
                desc: 'Gıda güvenliği mevzuatına tam uyumlu, FDA ve TSE onaylı malzemelerle üretim. Soğuk zincir dayanıklı yapı, dondurucuya dayanıklı baskı ve gıda teması onaylı mürekkeplerle güvenli çözümler.',
                tags: ['FDA & TSE Sertifikalı', 'Dondurucuya Dayanıklı', 'Barkod & QR Kod', 'Gıda Onaylı Mürekkep'],
                img: 'https://readdy.ai/api/search-image?query=professional%20food%20product%20labels%20on%20glass%20jars%20and%20bottles%20with%20clean%20colorful%20nutrition%20labels%20on%20white%20background%20high%20quality%20printing%20detail%20close%20up&width=260&height=160&seq=brosur-food-001&orientation=landscape',
              },
              {
                icon: 'ri-heart-pulse-line',
                color: '#B03A7B',
                title: 'Kozmetik Etiketleri',
                desc: 'Lüks görünüm ve uzun ömürlü dayanıklılık bir arada. Parlak, mat, hologram ve soft-touch yüzey seçenekleriyle kozmetik ürünlerinize premium değer katıyoruz.',
                tags: ['Soft Touch Laminasyon', 'Hologram Seçeneği', 'Parlak & Mat Yüzey', 'Lüks Tasarım'],
                img: 'https://readdy.ai/api/search-image?query=luxury%20cosmetic%20product%20labels%20on%20elegant%20bottles%20jars%20with%20premium%20gold%20design%20on%20soft%20pink%20background%20high%20end%20beauty%20packaging%20detail&width=260&height=160&seq=brosur-cosm-002&orientation=landscape',
              },
              {
                icon: 'ri-capsule-line',
                color: '#1A6B9A',
                title: 'İlaç Etiketleri',
                desc: 'Farmasötik sektörün katı standartlarına uygun GMP sertifikalı üretim. Güvenlik hologramı, seri numaralı baskı ve sahtecilik önleme özellikleriyle ilaç ambalajlarına tam çözüm.',
                tags: ['GMP Sertifikalı', 'Güvenlik Hologramı', 'Seri Numaralı Baskı', 'Sahtecilik Önleme'],
                img: 'https://readdy.ai/api/search-image?query=pharmaceutical%20medicine%20labels%20on%20pill%20bottles%20and%20medical%20packages%20clear%20dosage%20barcodes%20on%20light%20clinical%20background%20professional%20healthcare&width=260&height=160&seq=brosur-phar-003&orientation=landscape',
              },
              {
                icon: 'ri-tools-line',
                color: '#5D6D7E',
                title: 'Endüstriyel Etiketler',
                desc: 'Yüksek sıcaklık, kimyasal ve dış mekan kullanımına uygun özel malzeme etiketler. Zorlu koşullara dayanıklı, paslanmaz çelik ve lazer gravür seçenekleriyle makine plakaları.',
                tags: ['Yüksek Sıcaklık Dayanımı', 'Kimyasal Direnç', 'Dış Mekan UV Koruması', 'Lazer Gravür Opsiyonu'],
                img: 'https://readdy.ai/api/search-image?query=industrial%20product%20labels%20with%20barcodes%20warning%20symbols%20on%20machinery%20equipment%20durable%20weatherproof%20labels%20neutral%20gray%20background%20technical%20manufacturing&width=260&height=160&seq=brosur-ind-004&orientation=landscape',
              },
            ].map((s, i) => (
              <div key={i} className="flex gap-5 bg-[#FAFAF8] rounded-2xl overflow-hidden border border-gray-100">
                <div className="w-[200px] h-[130px] flex-shrink-0">
                  <img src={s.img} alt={s.title} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 py-4 pr-5">
                  <div className="flex items-center gap-2 mb-1.5">
                    <div
                      className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: s.color + '20' }}
                    >
                      <i className={`${s.icon} text-sm`} style={{ color: s.color }}></i>
                    </div>
                    <h3 className="text-base font-bold text-[#1A2332]">{s.title}</h3>
                  </div>
                  <p className="text-xs text-gray-600 leading-relaxed mb-2">{s.desc}</p>
                  <div className="flex flex-wrap gap-1">
                    {s.tags.map((t, j) => (
                      <span
                        key={j}
                        className="text-xs px-2 py-0.5 rounded-full font-medium"
                        style={{ backgroundColor: s.color + '15', color: s.color }}
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── SAYFA 3: ÜRÜN TİPLERİ & TEKNOLOJİ ── */}
        <div className="brochure-page bg-white mb-6 overflow-hidden" style={{ minHeight: '1123px' }}>
          {/* Başlık */}
          <div className="bg-[#FF6B35] px-10 py-6">
            <div className="flex items-end justify-between">
              <div>
                <span className="text-xs font-semibold tracking-widest text-white/70 uppercase">Ürün Portföyü</span>
                <h2 className="text-3xl font-bold text-white mt-1">Her İhtiyaca Özel Etiket Tipi</h2>
              </div>
              <img
                src="https://static.readdy.ai/image/09a8ead7418a68887e61601399480989/f761e44d359e887ba9b77959d97e14a2.png"
                alt="Bioetiket"
                className="h-8 w-auto opacity-80 invert"
              />
            </div>
          </div>

          <div className="px-10 py-6">
            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                { icon: 'ri-cup-line', title: 'Özel Kahve Poşet Etiketleri', desc: 'Aroma koruyucu kaplama, kraft ve mat laminasyon, özel form kesim' },
                { icon: 'ri-drop-line', title: 'Leksan Etiketler', desc: 'Su, yağ ve kimyasal dirençli polikarbonat malzeme etiketler' },
                { icon: 'ri-water-flash-line', title: 'Damla (3D Reçine) Etiket', desc: 'Epoksi reçine kaplama, premium 3D görünüm, çizilme koruması' },
                { icon: 'ri-focus-3-line', title: 'Lazer Etiket', desc: 'Mikron hassasiyetli kesim, hologram ve güvenlik baskısı' },
                { icon: 'ri-shield-check-line', title: 'Paslanmaz Çelik Etiket', desc: 'Alüminyum ve çelik yüzey, lazer gravür, kalıcı yapışkan' },
                { icon: 'ri-loop-right-line', title: 'Rulo Etiket', desc: 'Termal & dijital baskı, barkod yazıcı uyumlu, yüksek hacim' },
                { icon: 'ri-archive-line', title: 'Stok Ambalaj Etiketleri', desc: 'Hazır stok, minimum sipariş yok, 24 saat içinde kargo' },
                { icon: 'ri-qr-code-line', title: 'Barkod & QR Kod Etiketler', desc: 'GS1 standart barkodlar, QR, DataMatrix ve NFC destekli' },
              ].map((p, i) => (
                <div key={i} className="flex items-start gap-3 p-4 bg-[#FAFAF8] rounded-xl border border-gray-100">
                  <div className="w-9 h-9 bg-[#FF6B35]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${p.icon} text-lg text-[#FF6B35]`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-[#1A2332] mb-0.5">{p.title}</div>
                    <div className="text-xs text-gray-500 leading-relaxed">{p.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Teknoloji Bandı */}
            <div className="bg-[#1A2332] rounded-2xl p-7 mb-6">
              <h3 className="text-xl font-bold text-[#FF6B35] mb-5">Teknoloji &amp; Üretim Gücü</h3>
              <div className="grid grid-cols-3 gap-5 mb-5">
                {[
                  { icon: 'ri-speed-line', stat: '10.000', label: 'Etiket/Saat', desc: 'Son nesil dijital baskı makineleriyle yüksek hız üretim kapasitesi' },
                  { icon: 'ri-palette-line', stat: '12', label: 'Renk Baskı', desc: 'Pantone uyumlu 12 renk sistemiyle mükemmel renk doğruluğu' },
                  { icon: 'ri-truck-line', stat: '24 Saat', label: 'Teslimat', desc: 'Acil siparişlerde aynı gün üretim ve kargo güvencesi' },
                ].map((t, i) => (
                  <div key={i} className="text-center">
                    <div className="w-12 h-12 bg-[#FF6B35]/20 rounded-2xl flex items-center justify-center mx-auto mb-3">
                      <i className={`${t.icon} text-2xl text-[#FF6B35]`}></i>
                    </div>
                    <div className="text-3xl font-bold text-[#FF6B35] mb-0.5">{t.stat}</div>
                    <div className="text-xs text-white font-semibold mb-1">{t.label}</div>
                    <div className="text-xs text-gray-400 leading-relaxed">{t.desc}</div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-4 gap-3 pt-5 border-t border-white/10">
                {[
                  { v: '20+', l: 'Yıllık Deneyim' },
                  { v: '800+', l: 'Mutlu Müşteri' },
                  { v: '2M+', l: 'Üretilen Etiket' },
                  { v: '%98', l: 'Memnuniyet' },
                ].map((s, i) => (
                  <div key={i} className="text-center">
                    <div className="text-2xl font-bold text-white">{s.v}</div>
                    <div className="text-xs text-gray-400 mt-0.5">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ── SAYFA 4: İLETİŞİM & KAPANIŞ ── */}
        <div className="brochure-page bg-white overflow-hidden" style={{ minHeight: '1123px' }}>
          {/* Büyük Görsel Başlık */}
          <div className="relative h-80 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20business%20team%20working%20with%20label%20printing%20technology%20colorful%20product%20labels%20samples%20displayed%20on%20clean%20modern%20office%20table%20with%20orange%20accents%20and%20premium%20branding%20materials%20organized%20professionally&width=794&height=320&seq=brosur-contact-bg-001&orientation=landscape"
              alt="Bioetiket Ekip"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1A2332]/90 to-[#1A2332]/40"></div>
            <div className="absolute inset-0 flex flex-col justify-center px-12">
              <span className="text-xs font-semibold tracking-widest text-[#FF6B35] uppercase mb-3">İletişim</span>
              <h2 className="text-4xl font-bold text-white mb-3">
                Hemen Teklif Alın,<br />
                <span className="text-[#FF6B35]">Üretelim!</span>
              </h2>
              <p className="text-sm text-white/80 max-w-sm leading-relaxed">
                Ürününüze özel etiket çözümleri için bizimle iletişime geçin. Uzman ekibimiz en uygun çözümü size sunacak.
              </p>
            </div>
          </div>

          <div className="px-10 py-8">
            {/* İletişim Bilgileri */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="space-y-4">
                <h3 className="text-lg font-bold text-[#1A2332] mb-3">İletişim Bilgileri</h3>
                {[
                  { icon: 'ri-phone-line', label: 'Sabit Hat', val: '+90 216 365 88 78' },
                  { icon: 'ri-smartphone-line', label: 'Mobil', val: '+90 532 601 82 94' },
                  { icon: 'ri-customer-service-line', label: 'Satış Hattı', val: '+90 537 020 77 88' },
                  { icon: 'ri-mail-line', label: 'E-posta', val: 'info@bioetiket.com' },
                  { icon: 'ri-send-plane-line', label: 'Teklif', val: 'teklif@bioetiket.com' },
                  { icon: 'ri-global-line', label: 'Web', val: 'www.bioetiket.com' },
                ].map((c, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-[#FF6B35]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${c.icon} text-sm text-[#FF6B35]`}></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400">{c.label}</div>
                      <div className="text-sm font-semibold text-[#1A2332]">{c.val}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div>
                <h3 className="text-lg font-bold text-[#1A2332] mb-3">Adres &amp; Konum</h3>
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-8 h-8 bg-[#FF6B35]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-sm text-[#FF6B35]"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-[#1A2332]">Bioetiket</div>
                    <div className="text-xs text-gray-600 leading-relaxed">
                      Yukarı Dudullu Mah. Necip Fazıl Blv.<br />
                      No: 70, Ümraniye / İstanbul
                    </div>
                  </div>
                </div>
                <div className="rounded-2xl overflow-hidden border border-gray-100" style={{ height: '200px' }}>
                  <iframe
                    title="Bioetiket Konum"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.4!2d29.1183!3d41.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zWXVrYXLEsSBEdWR1bGx1!5e0!3m2!1str!2str!4v1!5m2!1str!2str"
                    width="100%"
                    height="200"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Neden Biz */}
            <div className="bg-[#FAFAF8] rounded-2xl p-6 mb-8">
              <h3 className="text-base font-bold text-[#1A2332] mb-4">Neden Bioetiket?</h3>
              <div className="grid grid-cols-3 gap-3">
                {[
                  { icon: 'ri-verified-badge-line', title: 'ISO Sertifikalı Üretim', desc: 'Kalite belgeli, standart uyumlu süreçler' },
                  { icon: 'ri-time-line', title: '24 Saat Acil Teslimat', desc: 'Acil siparişlerde aynı gün kargo' },
                  { icon: 'ri-file-list-3-line', title: '100 Adetten Üretim', desc: 'Küçük adetlerde de ekonomik fiyat' },
                  { icon: 'ri-brush-line', title: 'Ücretsiz Tasarım Desteği', desc: 'Uzman grafik ekibiyle tasarım yardımı' },
                  { icon: 'ri-recycle-line', title: 'Çevre Dostu Seçenekler', desc: 'Geri dönüşümlü ve biyobozunur malzeme' },
                  { icon: 'ri-customer-service-2-line', title: 'Satış Sonrası Destek', desc: '7 gün müşteri hizmetleri desteği' },
                ].map((w, i) => (
                  <div key={i} className="flex items-start gap-2">
                    <div className="w-8 h-8 bg-[#FF6B35]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${w.icon} text-sm text-[#FF6B35]`}></i>
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-[#1A2332]">{w.title}</div>
                      <div className="text-xs text-gray-500 leading-relaxed">{w.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Footer */}
            <div className="bg-[#1A2332] rounded-2xl px-8 py-5 flex items-center justify-between">
              <img
                src="https://static.readdy.ai/image/09a8ead7418a68887e61601399480989/f761e44d359e887ba9b77959d97e14a2.png"
                alt="Bioetiket"
                className="h-10 w-auto"
              />
              <div className="text-center">
                <div className="text-sm font-semibold text-white">Profesyonel Etiket Üretimi</div>
                <div className="text-xs text-gray-400 mt-0.5">20 Yıllık Deneyim · ISO Sertifikalı · Türkiye Geneli Teslimat</div>
              </div>
              <div className="text-right">
                <div className="text-sm font-bold text-[#FF6B35]">www.bioetiket.com</div>
                <div className="text-xs text-gray-400 mt-0.5">© 2025 Bioetiket</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: white !important; }
          .brochure-page { page-break-after: always; margin: 0 !important; box-shadow: none !important; }
          .brochure-wrapper { max-width: 100% !important; }
        }
        @media screen {
          .brochure-page { box-shadow: 0 4px 24px rgba(0,0,0,0.10); border-radius: 12px; }
        }
      `}</style>
    </div>
  );
}
